import { Progress } from '@mantine/core';

interface LimitProps {
    label?: string;
    value?: number;
    maxValue?: number;
    color?: string;
}

export default function Limit({
    label = 'Cloud quotas',
    value = 0,
    maxValue,
    color = 'blue',
}: LimitProps) {
    const pct = maxValue && maxValue > 0 ? (value / maxValue) * 100 : 0;
    const usage = `${value}/${maxValue ?? '—'}`;
    return (
        <div className="w-full flex flex-col justify-center items-center gap-1">
            <div className="w-full flex flex-row justify-between items-center">
                <h3 className="text-sm">{label}</h3>
                <span className="text-xs text-fg/70">{usage}</span>
            </div>
            <Progress
                value={pct}
                color={color}
                style={{ width: '100%', flex: 1 }}
                aria-label={`${label}: ${usage}`}
            />
        </div>
    );
}
